'use client';

import { Icon } from '@iconify/react';
import type { DataRefreshDatesResponseDto } from '../types';
import { DarkTooltip } from './dark-tooltip';

function formatRefreshDate(date: Date | string | undefined): string {
    if (!date) return 'N/A';
    const d = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(d.getTime())) return 'N/A';
    return d.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    });
}

/** Shared "Updates by Data Sets:" tooltip content, reused anywhere the same breakdown should show. */
export function DataSetUpdatesTooltipContent({
    dataRefreshDates,
}: {
    dataRefreshDates: DataRefreshDatesResponseDto;
}) {
    return (
        <div className="flex flex-col gap-0.5 px-2 py-2">
            <span className="mb-1.5 text-small font-extrabold text-white">
                Updates by Data Sets:
            </span>
            <span className="text-tiny text-white">
                Latest Data Refresh: {formatRefreshDate(dataRefreshDates.lastRefreshOverall)}
            </span>
            {Object.entries(dataRefreshDates.byType).map(([key, value]) => (
                <span key={key} className="text-tiny text-white">
                    {value.label}: {formatRefreshDate(value.lastRefresh)}
                </span>
            ))}
        </div>
    );
}

export function RefreshDataDates({
    dataRefreshDates,
}: {
    dataRefreshDates: DataRefreshDatesResponseDto;
}) {
    return (
        <DarkTooltip
            content={<DataSetUpdatesTooltipContent dataRefreshDates={dataRefreshDates} />}
            placement="top"
            size="sm"
            classNames={{ content: 'shadow-large rounded-md p-2 my-4' }}
        >
            <div className="flex cursor-default items-center justify-center gap-1 text-[12px] text-foreground">
                <Icon icon="lucide:info" width={14} className="text-foreground" />{' '}
                <span className="font-extrabold">Latest Data Refresh: </span>
                <span className="font-medium text-foreground/70">
                    {formatRefreshDate(dataRefreshDates.lastRefreshOverall)}
                </span>
            </div>
        </DarkTooltip>
    );
}
